/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import DbBaseObject from "@shared/DbBaseObject";
import DocSignElementType from "@/core/modules/DocSign/data/DocSignElementType";
import {AssignToData, AssignToOptions} from "@/core/modules/DocSign/data/DocSignAssignToData";

export default class BaseDocSignElement extends DbBaseObject{

	leftPercent: number = 0
	topPercent: number = 0
	widthPercent: number = 0
	heightPercent: number = 0

	left: number = 0
	top: number = 0
	width: number = 0
	height: number = 0

	isRequired: boolean = true
	isMultiline: boolean = true

	assignedTo: AssignToOptions = AssignToOptions.CLIENT
	itemType: DocSignElementType = "22"

	resizeable: boolean = true

	_visible: boolean = true
	_active: boolean = false
	_hover: boolean = false
	_isError: boolean = false


	constructor(left: number, top: number, width: number, height: number, type: string = null) {
		super();
		this.left = left;
		this.top = top;
		this.width = width;
		this.height = height;

		// this.itemType = type;

	}

	// get itemType() {
	// 	return this.itemTypeInternal
	// }
	//
	// set itemType(value) {
	// 	console.log("BaseDocSignElement: this.itemType value = ", value, ", this = ", this)
	// 	this.itemTypeInternal = value
	// }



	isAssignedToCoach(){
		return this.assignedTo === AssignToOptions.COACH
	}
	isAssignedToClient(){
		return this.assignedTo === AssignToOptions.CLIENT
	}

	isFilledIn(){

	}

	setError(isError){
		this._isError = isError
	}

	shouldDeleteOnBackspace(){
		return true
	}

	getAssignedToObject(){
		let res = null
		console.log("getAssignedToObject: this.assignedTo = ", this.assignedTo)
		AssignToData.forEach(assignedToOption => {
			console.log("getAssignedToObject: assignedToOption = ", assignedToOption)
			if(assignedToOption.value === this.assignedTo){
				res = assignedToOption
			}
		})
		console.log("getAssignedToObject: res = ", res)
		return res
	}

	setPositionFromPercent(pageWidth, pageHeight){
		this.left = Math.floor(pageWidth * this.leftPercent)
		this.top = Math.floor(pageHeight * this.topPercent)
		this.width = Math.floor(pageWidth * this.widthPercent)
		this.height = Math.floor(pageHeight * this.heightPercent)
	}

	setPercentFromPosition(pageWidth, pageHeight){
		this.leftPercent = this.left / pageWidth
		this.topPercent = this.top / pageHeight
		this.widthPercent = this.width / pageWidth
		this.heightPercent = this.height / pageHeight
		let obj = {
			left: this.left,
			top: this.top,
			leftPercent: this.leftPercent,
			topPercent: this.topPercent
		}
		console.log("setPercentFromPosition: pageWidth = ", pageWidth, ", pageHeight = ", pageHeight, ", obj = ", obj, ", this = ", this)
	}
}
